import { PlusOutlined, SearchOutlined, FilterOutlined, DownloadOutlined, EditOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Space, Spin, Switch, Table, Tag, Input, Card, Row, Col, Modal, Form, InputNumber, message } from 'antd';
import frFR from "antd/locale/fr_FR";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../../components/Footer';
import NavBar from '../../../components/NavBar';
import SideBar from '../../../components/SideBar';
import { rightsService } from '../../../services/rightsService';
import { LOGGED_USER } from '../../../variables/constants';
import axiosInstance from '../../../variables/api/axiosInstance';
import { StatCard } from '../../../components/statistics/StatCard';

const Courtiers = () => {
    const [courtiers, setCourtiers] = useState([]);
    const [contrats, setContrats] = useState(0);
    const [loadingCourtiers, setLoadingCourtiers] = useState(true);
    const [selecting, setSelecting] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [searchText, setSearchText] = useState('');
    const [commissionModalVisible, setCommissionModalVisible] = useState(false);
    const [currentCourtier, setCurrentCourtier] = useState(null);
    const [form] = Form.useForm();

    const navigate = useNavigate();

    // Palette de couleurs professionnelle
    const colors = {
        primary: '#1890ff',
        secondary: '#242166',
        success: '#52c41a',
        warning: '#faad14',
        danger: '#ff4d4f',
        info: '#13c2c2',
        lightBg: '#f5f7fa',
        cardBg: '#ffffff',
        textPrimary: '#262626',
        textSecondary: '#8c8c8c',
        border: '#e8e8e8',
        gradient: 'linear-gradient(135deg, #1890ff 0%, #242166 100%)',
    };

    const handleChange = (pagination, filters, sorter) => {
        console.log("Various parameters", pagination, filters, sorter);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const openCommissionModal = (record) => {
        setCurrentCourtier(record);
        // Initialiser le formulaire avec les données existantes
        form.setFieldsValue({
            commissionVie: record.commissionVie || 0,
            commissionNonVie: record.commissionNonVie || 0,
            commissionSante: record.commissionSante || 0,
            commissionAuto: record.commissionAuto || 0,
            commissionIARD: record.commissionIARD || 0,
        });
        setCommissionModalVisible(true);
    };

    const handleCommissionSubmit = async () => {
        try {
            const values = await form.validateFields();
            // Envoyer les données au backend
            await axiosInstance.put(`/api/agence/courtier/${currentCourtier.codeId}/commissions`, values);
            message.success('Taux de commissions mis à jour avec succès');
            setCommissionModalVisible(false);
            // Recharger les données
        } catch (error) {
            message.error('Erreur lors de la mise à jour des commissions');
        }
    };

    const columns = [
        {
            title: "Code Courtier",
            dataIndex: "codeAgence",
            key: "1",
            sorter: (a, b) => a.codeAgence.localeCompare(b.codeAgence),
            sortOrder: sortedInfo.columnKey === '1' ? sortedInfo.order : null,
        },
        {
            title: "Nom complet",
            dataIndex: "nom",
            key: "2",
            sorter: (a, b) => a.nom.localeCompare(b.nom),
            sortOrder: sortedInfo.columnKey === '2' ? sortedInfo.order : null,
            filteredValue: filteredInfo.nom || null,
            onFilter: (value, record) => record.nom.toLowerCase().includes(value.toLowerCase()),
        },
        {
            title: "Agréements",
            dataIndex: "agreements",
            key: "3",
            render: (_, record) => (
                <Space size={[0, 4]} wrap>
                    {LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" ?
                        record?.validAgrements?.length ?
                            record.validAgrements.map((va, id) => (
                                <Tag
                                    style={{
                                        background: colors.lightBg,
                                        border: `1px solid ${colors.primary}`,
                                        color: colors.primary,
                                        borderRadius: '16px',
                                        padding: '2px 12px'
                                    }}
                                    key={id}
                                >
                                    {va.compagnie.raisonSociale}
                                </Tag>
                            ))
                            : <Tag style={{ color: colors.textSecondary }}>Aucun agréement validé</Tag>
                        : validatedAgency(record) ?
                            <Tag style={{
                                background: '#f6ffed',
                                border: `1px solid ${colors.success}`,
                                color: colors.success,
                                borderRadius: '16px',
                                padding: '2px 12px'
                            }}>
                                Agréé
                            </Tag>
                            :
                            <Tag style={{
                                background: '#fff2f0',
                                border: `1px solid ${colors.danger}`,
                                color: colors.danger,
                                borderRadius: '16px',
                                padding: '2px 12px'
                            }}>
                                Non agréé
                            </Tag>
                    }
                </Space>
            )
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "4",
            width: 120,
            render: (_, record) => (
                <Space>
                    <Button
                        // type="primary"
                        icon={<i className="bx bx-dots-horizontal-rounded" />}
                        // shape="circle"
                        // style={{ background: colors.primary, borderColor: colors.primary }}
                        onClick={() => { navigate(`/courtier/${record.codeId}`) }}
                        title="Voir détails"
                    />
                    {/* <Button
                        icon={<EditOutlined />}
                        shape="circle"
                        style={{ color: colors.secondary, borderColor: colors.secondary }}
                        onClick={() => openCommissionModal(record)}
                        title="Modifier commissions"
                    /> */}
                </Space>
            ),
        },
    ];

    const onSelectChange = (newSelectedRowKeys, rows) => {
        console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        console.log("SelectedRows", rows);
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const validatedAgency = (agency) => {
        let v = 0;
        v = agency?.validAgrements.findIndex(ag => ag.compagnie.code === LOGGED_USER?.profil?.organisme?.code);
        return v !== -1;
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const filteredCourtiers = courtiers.filter(courtier =>
        courtier.nom?.toLowerCase().includes(searchText.toLowerCase()) ||
        courtier.codeAgence?.toLowerCase().includes(searchText.toLowerCase())
    );

    useEffect(() => {
        axiosInstance
            .get(`/api/agence/all/courtiers`)
            .then((res) => {
                console.log(res.data);
                setCourtiers(res.data);
                setLoadingCourtiers(false);
            })
            .catch((err) => {
                console.log(err);
                setLoadingCourtiers(false);
            });
    }, []);

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SideBar currentMenu={"COURTIERS"} />

                <div className="layout-page">
                    <NavBar />

                    <div className="content-wrapper" style={{ background: colors.lightBg }}>
                        <div className="container-xxl flex-grow-1 container-p-y">
                            {/* Statistiques */}
                            <Row gutter={[24, 24]} style={{ marginBottom: '24px' }}>
                                <Col xs={24} sm={12} xl={6}>
                                    <StatCard
                                        title="Total Courtiers"
                                        value={courtiers?.length || 0}
                                        subtitle="Courtiers enregistrés"
                                        icon="bx bx-group"
                                        iconBg={colors.gradient}
                                        gradient={colors.gradient}
                                    />
                                </Col>
                                <Col xs={24} sm={12} xl={6}>
                                    <StatCard
                                        title="Contrats"
                                        value={contrats}
                                        subtitle="Rapportés par les courtiers"
                                        icon="bx bx-file"
                                        iconBg="linear-gradient(135deg, #fa8c16 0%, #faad14 100%)"
                                        gradient="linear-gradient(135deg, #fa8c16 0%, #faad14 100%)"
                                    />
                                </Col>
                                <Col xs={24} sm={12} xl={6}>
                                    <StatCard
                                        title="Agréés"
                                        value={courtiers.filter(c => validatedAgency(c)).length}
                                        subtitle="Courtiers agréés"
                                        icon="bx bx-check-circle"
                                        iconBg="linear-gradient(135deg, #52c41a 0%, #73d13d 100%)"
                                        gradient="linear-gradient(135deg, #52c41a 0%, #73d13d 100%)"
                                    />
                                </Col>
                                <Col xs={24} sm={12} xl={6}>
                                    <StatCard
                                        title="En attente"
                                        value={courtiers.filter(c => !validatedAgency(c)).length}
                                        subtitle="En cours de validation"
                                        icon="bx bx-time-five"
                                        iconBg="linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)"
                                        gradient="linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)"
                                    />
                                </Col>
                            </Row>

                            {/* Tableau des courtiers */}
                            <Card
                                bordered={false}
                                style={{
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                }}
                                bodyStyle={{ padding: '24px' }}
                            >
                                <div style={{ marginBottom: '24px' }}>
                                    <Row gutter={[16, 16]} align="middle">
                                        <Col xs={24} md={12}>
                                            <Space size="middle">
                                                {rightsService("HLA043") && (
                                                    <Button
                                                        type="primary"
                                                        icon={<PlusOutlined />}
                                                        onClick={() => navigate("/ajouter-courtier")}
                                                        style={{
                                                            background: colors.gradient,
                                                            borderColor: colors.secondary,
                                                            borderRadius: '8px',
                                                            height: '40px',
                                                            fontWeight: '500',
                                                            boxShadow: '0 2px 4px rgba(36, 33, 102, 0.2)'
                                                        }}
                                                    >
                                                        Nouveau courtier
                                                    </Button>
                                                )}
                                                <Button
                                                    icon={<DownloadOutlined />}
                                                    style={{
                                                        borderRadius: '8px',
                                                        height: '40px',
                                                        borderColor: colors.border
                                                    }}
                                                >
                                                    Exporter
                                                </Button>
                                            </Space>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Space style={{ width: '100%', justifyContent: 'flex-end' }} size="middle">
                                                <Input
                                                    placeholder="Rechercher un courtier..."
                                                    prefix={<SearchOutlined style={{ color: colors.textSecondary }} />}
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    style={{
                                                        width: '280px',
                                                        borderRadius: '8px',
                                                        height: '40px'
                                                    }}
                                                />
                                                <Space align="center">
                                                    <span style={{ color: colors.textSecondary, fontSize: '14px' }}>
                                                        Sélection
                                                    </span>
                                                    <Switch
                                                        checked={selecting}
                                                        onChange={setSelecting}
                                                        style={{
                                                            background: selecting ? colors.primary : undefined
                                                        }}
                                                    />
                                                </Space>
                                            </Space>
                                        </Col>
                                    </Row>
                                </div>

                                <ConfigProvider locale={frFR}>
                                    <Spin spinning={loadingCourtiers}>
                                        <Table
                                            rowSelection={selecting ? rowSelection : undefined}
                                            columns={columns}
                                            dataSource={filteredCourtiers}
                                            onChange={handleChange}
                                            pagination={{
                                                pageSize: 10,
                                                showSizeChanger: true,
                                                showTotal: (total) => `Total: ${total} courtiers`,
                                                style: { marginTop: '16px' }
                                            }}
                                            style={{
                                                background: colors.cardBg,
                                            }}
                                            rowKey="codeId"
                                        />
                                    </Spin>
                                </ConfigProvider>
                            </Card>
                        </div>

                        <Footer />
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>

            {/* Modal pour les commissions */}
            <Modal
                title={
                    <div style={{
                        fontSize: '18px',
                        fontWeight: '600',
                        color: colors.textPrimary,
                        borderBottom: `1px solid ${colors.border}`,
                        paddingBottom: '12px',
                        marginBottom: '16px'
                    }}>
                        Taux de commissions - {currentCourtier?.nom}
                    </div>
                }
                open={commissionModalVisible}
                onOk={handleCommissionSubmit}
                onCancel={() => setCommissionModalVisible(false)}
                width={700}
                okText="Enregistrer"
                cancelText="Annuler"
                okButtonProps={{
                    style: {
                        background: colors.gradient,
                        borderColor: colors.secondary,
                        borderRadius: '6px',
                        height: '36px'
                    }
                }}
                cancelButtonProps={{
                    style: {
                        borderRadius: '6px',
                        height: '36px'
                    }
                }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    style={{ marginTop: '24px' }}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label={<span style={{ fontWeight: '500' }}>Commission Vie (%)</span>}
                                name="commissionVie"
                                rules={[{ required: true, message: 'Requis' }]}
                            >
                                <InputNumber
                                    min={0}
                                    max={100}
                                    precision={2}
                                    style={{ width: '100%', borderRadius: '6px' }}
                                    placeholder="0.00"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={<span style={{ fontWeight: '500' }}>Commission Non-Vie (%)</span>}
                                name="commissionNonVie"
                                rules={[{ required: true, message: 'Requis' }]}
                            >
                                <InputNumber
                                    min={0}
                                    max={100}
                                    precision={2}
                                    style={{ width: '100%', borderRadius: '6px' }}
                                    placeholder="0.00"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label={<span style={{ fontWeight: '500' }}>Commission Santé (%)</span>}
                                name="commissionSante"
                                rules={[{ required: true, message: 'Requis' }]}
                            >
                                <InputNumber
                                    min={0}
                                    max={100}
                                    precision={2}
                                    style={{ width: '100%', borderRadius: '6px' }}
                                    placeholder="0.00"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={<span style={{ fontWeight: '500' }}>Commission Auto (%)</span>}
                                name="commissionAuto"
                                rules={[{ required: true, message: 'Requis' }]}
                            >
                                <InputNumber
                                    min={0}
                                    max={100}
                                    precision={2}
                                    style={{ width: '100%', borderRadius: '6px' }}
                                    placeholder="0.00"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label={<span style={{ fontWeight: '500' }}>Commission IARD (%)</span>}
                                name="commissionIARD"
                                rules={[{ required: true, message: 'Requis' }]}
                            >
                                <InputNumber
                                    min={0}
                                    max={100}
                                    precision={2}
                                    style={{ width: '100%', borderRadius: '6px' }}
                                    placeholder="0.00"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div style={{
                    background: colors.lightBg,
                    padding: '12px',
                    borderRadius: '8px',
                    marginTop: '16px'
                }}>
                    <p style={{
                        margin: 0,
                        fontSize: '12px',
                        color: colors.textSecondary,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <i className="bx bx-info-circle" style={{ fontSize: '16px', color: colors.info }} />
                        Les taux de commission seront appliqués à tous les nouveaux contrats
                    </p>
                </div>
            </Modal>

            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
        </div>
    );
};

export default Courtiers;